export default {
    message: {
        buscar_calles: 'Cercador de carrers ...',
        valenciano: 'Valencià',
        castellano: 'Castellà',
    },

    escenario: 'Escenari',

    panel_layers: {
        btn_catalogo: 'Catàleg',
    },

    "paginacion": {
        "anterior": "Anterior",
        "siguiente": "Següent",
    },

    capas_encontradas:'capes trobades',
    no_resultados: 'No hi ha resultats',
    no_descripcion: 'No hi ha descripció.',
    ver_en_mapa: 'Veure al mapa',

    descargar_capa: 'Descarregar capa',
    catalogo_desactivado: 'Temporalment estan deshabilitats els serveis del catàleg. No obstant això pots posar-te en contacte amb nosaltres a través del formulari de suggeriment o info@sigogestion.com. Si necessites que et facilitem alguna capa o accés al servei. En breu tornaràs a estar operatius. Disculpa les molèsties',
    informacion: 'Informació',
    volver_al_catalogo: 'Tornar al catàleg',
    campos: {
        titulo: "Títol",
        descripcion: "Descripció",
        fecha_publicacion: "Data publicació",
        fecha_actualizacion: "Data actualització",
    },
    atributos: 'Atributs',
    campos_atributos: {
        nombre: 'Nom de l\'atribut',
        etiqueta: 'Etiqueta',
        descripcion: 'Descripció',
    },
    no_attributos: 'No hi ha atributs',

    panel_filtros: {
        titulo: 'Filtres',
        limpiar: 'Netejar',
        texto: 'Text',
        grupo: 'Grup',
        buscar: 'Cercar'
    },
}

